import always from './always';

/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T = /*#__PURE__*/always(true);
export default T;


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/T.js
// module id = 1739
// module chunks = 1